import React, { useState } from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Layout } from 'components/Layout';
import { getPageStaticProps } from 'lib/dato-request';

const Sona = ({ data }) => {
    const { page } = data;
    // const { components, seo } = page;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        setStatusMessage('');

        try {
            // 1. Hit dummy endpoint
            const dummyResponse = await fetch('https://jsonplaceholder.typicode.com/posts', {
                method: 'POST',
                body: JSON.stringify({ name, email, title: 'Sona Form Submission', userId: 1 }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8'
                }
            });

            if (!dummyResponse.ok) {
                throw new Error(`Dummy API error: ${dummyResponse.statusText}`);
            }
            console.log('Dummy API response:', await dummyResponse.json());

            // 2. Hit webhook
            const webhookResponse = await fetch('https://kyle-muzology.app.n8n.cloud/webhook-test/aa549e5d-a8e4-4667-a3fc-581f99269077', {
                method: 'POST',
                body: JSON.stringify({ name, email, source: 'Sona Page Form' }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!webhookResponse.ok) {
                // If webhook fails, we might still consider the primary action (dummy endpoint) a "partial" success
                // or treat the whole thing as a failure. For now, let's show specific error for webhook.
                throw new Error(`Webhook error: ${webhookResponse.statusText}`);
            }
            console.log('Webhook response status:', webhookResponse.status);

            // 3. Show success message
            setStatusMessage('Form submitted successfully!');
            setName('');
            setEmail('');
        } catch (error) {
            console.error('Form submission error:', error);
            setStatusMessage(`Error: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Layout showClassCodeInput={false} hideNavigationMenu={true} showLoginAndSignup={false}>
            {/* <NextSeo title={seo?.title ?? page.slug} description={seo?.description} /> */}
            {/* <Head>
                <meta name='keywords' content={page.keywords} />
            </Head> */}
            <div className='bg-home-background w-full min-h-[100vh] font-Lexend relative z-0 pt-[80px] xl:pt-[110px] flex flex-col items-center'>
                {/* blur effect pink */}
                <div className='hidden md:block absolute top-[-50px] right-0 rounded-full opacity-[1.4] bg-[#B031FA] bg-opacity-[0.7] blur-[250px] w-[729px] h-[585px] z-[1]' />
                {/* blur effect dark purple */}
                <div className='hidden md:block absolute top-[-50px] left-0 rounded-full opacity-[1.4] bg-[#161042] bg-opacity-[0.7] blur-[250px] w-[729px] h-[585px] z-[1]' />

                <div className='p-8 bg-white rounded-xl shadow-xl z-10 w-full max-w-xl mt-10 '>
                    <h2 className='text-2xl font-bold text-gray-800 mb-6 text-center'>Join Muzology</h2>
                    <form onSubmit={handleSubmit} className='space-y-6'>
                        <div>
                            <label htmlFor='name' className='block text-sm font-medium text-gray-700'>
                                Name
                            </label>
                            <input
                                type='text'
                                name='name'
                                id='name'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                className='mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm'
                                placeholder='Your Name'
                            />
                        </div>
                        <div>
                            <label htmlFor='email' className='block text-sm font-medium text-gray-700'>
                                Email
                            </label>
                            <input
                                type='email'
                                name='email'
                                id='email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className='mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 sm:text-sm'
                                placeholder='you@example.com'
                            />
                        </div>
                        <div>
                            <button
                                type='submit'
                                disabled={isLoading}
                                className='w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-yellow-400 hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50'
                            >
                                {isLoading ? 'Submitting...' : 'Submit'}
                            </button>
                        </div>
                    </form>
                    {statusMessage && (
                        <p className={`mt-4 text-sm text-center ${statusMessage.startsWith('Error:') ? 'text-red-600' : 'text-green-600'}`}>{statusMessage}</p>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Sona');
}

export default Sona;
